import { render, staticRenderFns } from "./ManageSocials.vue?vue&type=template&id=e43b1dae"
import script from "./ManageSocials.vue?vue&type=script&lang=js"
export * from "./ManageSocials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports